// Single chokepoint for runtime error reporting.
//
// Today this is a console.* wrapper. When Sentry is wired up, the install()
// call gets replaced with `Sentry.init({...})` and reportError/reportInfo
// delegate to Sentry.captureException / captureMessage. Everything that
// imports from here keeps working without churn.

const DSN = process.env.REACT_APP_SENTRY_DSN || '';

let installed = false;

export const install = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  // Browser-level errors that escape React's component tree
  window.addEventListener('error', (event) => {
    reportError(event.error || new Error(event.message), {
      source: 'window.error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  // Promise rejections that nothing catches
  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason instanceof Error ? event.reason : new Error(String(event.reason)), {
      source: 'unhandledrejection',
    });
  });

  // TODO: when REACT_APP_SENTRY_DSN is set, swap this for Sentry.init({...}).
  // Until then we just keep the listeners + console fallback.
  if (DSN) {
    // Sentry will be initialised here. See DEPLOYMENT-OPTIMIZATION-NOTES.md §7.
  }
};

export const reportError = (error, context = {}) => {
  // eslint-disable-next-line no-console
  console.error('[error]', error, context);
};

export const reportInfo = (message, context = {}) => {
  // eslint-disable-next-line no-console
  console.warn('[info]', message, context);
};
